import type { ComponentType } from 'react';
import {
  __federation_method_setRemote,
  __federation_method_getRemote,
  __federation_method_unwrapDefault,
} from 'virtual:__federation__';

/**
 * Load a federated remote's exposed component at RUNTIME from a registry-provided URL.
 * The remote is not known at the shell's build time — it's registered on demand.
 *
 * Only meaningful in the `--mode federation` build (the harness / a real deploy). In
 * dev/plain builds the virtual module is a no-op stub, so callers should gate on
 * `import.meta.env.MODE === 'federation'` before invoking (RemoteMount does).
 */
export async function loadRemoteModule(
  name: string,
  url: string,
  exposed = './Module',
): Promise<ComponentType> {
  __federation_method_setRemote(name, { url, format: 'esm', from: 'vite' });
  const mod = await __federation_method_getRemote(name, exposed);
  const cmp = await __federation_method_unwrapDefault(mod);
  return cmp as ComponentType;
}
